import { render, staticRenderFns } from "./VCardFooter.vue?vue&type=template&id=5bf1da91&scoped=true&"
import script from "./VCardFooter.vue?vue&type=script&lang=js&"
export * from "./VCardFooter.vue?vue&type=script&lang=js&"
import style0 from "./VCardFooter.vue?vue&type=style&index=0&id=5bf1da91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf1da91",
  null
  
)

export default component.exports